import {Routes} from '@angular/router';
import {ActivityDashboardComponent} from './activity-dashboard/activity-dashboard.component';
import {CallLogsComponent} from './call-logs/call-logs.component';
import {UsersSummaryComponent} from './users-summary/users-summary.component';
import {AgentGroupsDashboardComponent} from './agent-groups-dashboard/agent-groups-dashboard.component';
import {AgentGroupsSummaryComponent} from './agent-groups-summary/agent-groups-summary.component';
import {AuthGuard} from '../core/security/auth-guard.service';
import {MenuGroupEnum} from '../core/security/menu-group.enum';
import {ModulesEnum} from '../core/security/modules.enum';
import {RolesEnum} from '../core/security/roles.enum';
import {HuntGroupsDashboardComponent} from './hunt-groups-dashboard/hunt-groups-dashboard.component';
import {CustomReportEditComponent} from './custom-reports/edit/edit.component';
import {CustomReportListComponent} from './custom-reports/list/list.component';
import {CallLogsV2Component} from './call-logs-v2/call-logs-v2.component';
import {GroupsSummaryV2Component} from './groups-summary-v2/groups-summary-v2.component';
import {UsersSummaryV2Component} from './users-summary-v2/users-summary-v2.component';
import {CustomReportUnsubscribeComponent} from './custom-reports/unsubscribe/unsubscribe.component';
import {ActivityDashboardV2Component} from './activity-dashboard-v2/activity-dashboard-v2.component';

export const routes: Routes = [
  {
    path: 'activity-dashboard',
    component: ActivityDashboardComponent,
    canActivate: [AuthGuard],
    data: {
      menuGroup: MenuGroupEnum.LegacyReportsGroup,
      package: ModulesEnum.ActivityDashboardModule,
      permissions: [RolesEnum.ActivityDashboard_View, RolesEnum.ActivityDashboard_Edit, RolesEnum.ActivityDashboard_Delete],
      meta: {
        title: 'Main Dashboard',
        override: true,
        description: 'Main Dashboard page',
        inSideMenu: true,
        iconClass: 'fa fa-tachometer-alt',
        showDisabled: false,
        badge: 'deprecated'
      }
    }
  },
  {
    path: 'activity-dashboard-v2',
    component: ActivityDashboardV2Component,
    canActivate: [AuthGuard],
    data: {
      menuGroup: MenuGroupEnum.ReportsGroup,
      package: ModulesEnum.ActivityDashboardV2Module,
      permissions: [RolesEnum.ActivityDashboard_View, RolesEnum.ActivityDashboard_Edit, RolesEnum.ActivityDashboard_Delete],
      meta: {
        title: 'Main Dashboard',
        override: true,
        description: 'Main Dashboard page',
        inSideMenu: true,
        iconClass: 'fa fa-tachometer-alt',
        showDisabled: false,
        badge: 'none'
      }
    }
  },
  {
    path: 'call-logs',
    component: CallLogsComponent,
    canActivate: [AuthGuard],
    data: {
      menuGroup: MenuGroupEnum.LegacyReportsGroup,
      package: ModulesEnum.CallLogsModule,
      permissions: [RolesEnum.CallLogs_View, RolesEnum.CallLogs_Edit, RolesEnum.CallLogs_Delete],
      meta: {
        title: 'Call Logs',
        override: true,
        description: 'Call Logs Page',
        inSideMenu: true,
        iconClass: 'material-icons',
        iconClassCode: 'description',
        badge: 'deprecated'
      }
    }
  },
  {
    path: 'call-logs-v2',
    component: CallLogsV2Component,
    canActivate: [AuthGuard],
    data: {
      menuGroup: MenuGroupEnum.ReportsGroup,
      package: ModulesEnum.CallLogsV2Module,
      permissions: [RolesEnum.CallLogs_View, RolesEnum.CallLogs_Edit, RolesEnum.CallLogs_Delete],
      meta: {
        title: 'Call Logs',
        override: true,
        description: 'Call Logs Page',
        inSideMenu: true,
        iconClass: 'material-icons',
        iconClassCode: 'description',
        showDisabled: false,
        badge: 'none'
      }
    }
  },
  {
    path: 'users-list',
    component: UsersSummaryComponent,
    canActivate: [AuthGuard],
    data: {
      menuGroup: MenuGroupEnum.LegacyReportsGroup,
      package: ModulesEnum.UsersSummaryModule,
      permissions: [RolesEnum.UsersSummary_View, RolesEnum.UsersSummary_Edit, RolesEnum.UsersSummary_Delete],
      meta: {
        title: 'Agents Summary',
        override: true,
        description: 'Agents Summary Page',
        inSideMenu: true,
        iconClass: 'fa fa-user',
        badge: 'deprecated'
      }
    }
  },
  {
    path: 'users-summary-v2',
    component: UsersSummaryV2Component,
    canActivate: [AuthGuard],
    data: {
      menuGroup: MenuGroupEnum.ReportsGroup,
      package: ModulesEnum.UsersSummaryV2Module,
      permissions: [RolesEnum.UsersSummary_View, RolesEnum.UsersSummary_Edit, RolesEnum.UsersSummary_Delete],
      meta: {
        title: 'Agents Summary',
        override: true,
        description: 'Agents Summary Page',
        inSideMenu: true,
        iconClass: 'fa fa-user',
        showDisabled: false,
        badge: 'none'
      }
    }
  },
  {
    path: 'agent-groups-dashboard',
    component: AgentGroupsDashboardComponent,
    canActivate: [AuthGuard],
    data: {
      menuGroup: MenuGroupEnum.LegacyReportsGroup,
      package: ModulesEnum.GroupsDashboardModule,
      permissions: [RolesEnum.GroupsDashboard_View, RolesEnum.GroupsDashboard_Edit, RolesEnum.GroupsDashboard_Delete],
      meta: {
        title: 'Agent Groups Dashboard',
        override: true,
        description: 'Agent Groups Dashboard Page',
        inSideMenu: true,
        iconClass: 'fa fa-group',
        badge: 'deprecated'
      }
    }
  },
  {
    path: 'agent-groups-list',
    component: AgentGroupsSummaryComponent,
    canActivate: [AuthGuard],
    data: {
      menuGroup: MenuGroupEnum.LegacyReportsGroup,
      package: ModulesEnum.GroupsSummaryModule,
      permissions: [RolesEnum.GroupsSummary_View, RolesEnum.GroupsSummary_Edit, RolesEnum.GroupsSummary_Delete],
      meta: {
        title: 'Groups Summary',
        override: true,
        description: 'Agent Groups Summary Page',
        inSideMenu: true,
        iconClass: 'fa fa-list',
        badge: 'deprecated'
      }
    }
  },
  {
    path: 'groups-summary-v2',
    component: GroupsSummaryV2Component,
    canActivate: [AuthGuard],
    data: {
      menuGroup: MenuGroupEnum.ReportsGroup,
      package: ModulesEnum.GroupsSummaryV2Module,
      permissions: [RolesEnum.GroupsSummary_View, RolesEnum.GroupsSummary_Edit, RolesEnum.GroupsSummary_Delete],
      meta: {
        title: 'Groups Summary',
        override: true,
        description: 'Groups Summary Page',
        inSideMenu: true,
        iconClass: 'fa fa-list',
        showDisabled: false,
        badge: 'none'
      }
    }
  },
  {
    path: 'hunt-groups-dashboard',
    component: HuntGroupsDashboardComponent,
    canActivate: [AuthGuard],
    data: {
      menuGroup: MenuGroupEnum.LegacyReportsGroup,
      package: ModulesEnum.HuntGroupsDashboardModule,
      permissions: [RolesEnum.HuntGroupsDashboardView, RolesEnum.HuntGroupsDashboardEdit, RolesEnum.HuntGroupsDashboardDelete],
      meta: {
        title: 'Hunt Groups Dashboard',
        override: true,
        description: 'Hunt Groups Dashboard Page',
        inSideMenu: true,
        iconClass: 'fa fa-group',
        badge: 'deprecated'
      }
    }
  },
  {
    path: 'custom-reports',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        canActivate: [AuthGuard],
        children: [
          {
            path: 'list',
            component: CustomReportListComponent,
            canActivate: [AuthGuard],
            data: {
              menuGroup: MenuGroupEnum.ReportsGroup,
              package: ModulesEnum.CustomReportsModule,
              permissions: [RolesEnum.CustomReportsView, RolesEnum.CustomReportsEdit, RolesEnum.CustomReportsDelete],
              meta: {
                title: 'Custom Reports',
                override: true,
                description: 'Custom Reports',
                inSideMenu: true,
                iconClass: 'material-icons',
                iconClassCode: 'insert_chart_outlined',
                showDisabled: false
              }
            }
          },
          {
            path: 'edit',
            canActivate: [AuthGuard],
            children: [
              {
                path: ':id',
                component: CustomReportEditComponent,
                canActivate: [AuthGuard],
                data: {
                  menuGroup: MenuGroupEnum.ReportsGroup,
                  package: ModulesEnum.CustomReportsModule,
                  permissions: [RolesEnum.CustomReportsView, RolesEnum.CustomReportsEdit, RolesEnum.CustomReportsDelete],
                  meta: {
                    title: 'Edit Report',
                    override: true,
                    description: 'Edit Custom Report',
                    inSideMenu: false,
                    iconClass: 'material-icons',
                    iconClassCode: 'insert_chart_outlined',
                  }
                }
              }
            ]
          },
          {
            path: 'unsubscribe',
            component: CustomReportUnsubscribeComponent,
            canActivate: [AuthGuard],
            data: {
              menuGroup: MenuGroupEnum.ReportsGroup,
              package: ModulesEnum.CustomReportsModule,
              permissions: [RolesEnum.CustomReportsView, RolesEnum.CustomReportsEdit, RolesEnum.CustomReportsDelete],
              meta: {
                title: 'Unsubscribe',
                override: true,
                description: 'Unsubscribe From Reports',
                inSideMenu: false,
                iconClass: 'material-icons',
                iconClassCode: 'insert_chart_outlined',
                showDisabled: false
              }
            }
          },
        ]
      }
    ]
  },
];
